module.exports = __webpack_public_path__ + "static/img/114.e9f05d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/digital/news/114.png
// module id = Q9oo
// module chunks = 0